import { styled } from '../../../theme';
import { Paragraph } from '../../Paragraph';

export const $Paragraph = styled(Paragraph).attrs({})`
	margin-bottom: 0;
	padding-top: ${({ theme }) => theme.space.md}px;
`;
